'use strict';

var globalThis = require('../internals/global-this');
module.exports = globalThis.Promise;